import React, { useEffect, useRef } from 'react';
import './Main.css';
import { GridRow, GridColumn, Grid, Input, TextArea, Button, Icon } from 'semantic-ui-react'
import IconCloud from './IconClould';
import ReactConf from './images/social-image.png'
import profilePic from './images/image.png'
import TypingAnimation from './Components/TypingAnimation';
import emailjs from '@emailjs/browser';
import Scrollbar from 'smooth-scrollbar';
import Gliter from './images/gliter.png';
import { gsap } from "gsap";
function Main({ refs }){

    const form = useRef();
    const containerRef = useRef(null);
    const imageIndexRef = useRef(0);
    const lastCreatedTimeRef = useRef(0);
    const lastPositionRef = useRef({ x: 0, y: 0 });


    const images = [
      Gliter,
      Gliter,
      Gliter,
      Gliter,
      Gliter,
      Gliter,
      ];

    useEffect(() => {
        const revealElements = document.querySelectorAll(".reveal");
    
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("show"); // Add 'show' when in view
              } else {
                entry.target.classList.remove("show"); // Remove 'show' when out of view
              }
            });
          },
          { threshold: 0.1 } // Trigger when 10% of the element is visible
        );
    
        revealElements.forEach((element) => {
          observer.observe(element); // Keep observing each element
        });
    
        // Cleanup observer on component unmount
        Scrollbar.init(document.querySelector('#smooth-scroll-container'), {
          damping: 0.05, // Adjust damping for smoother or faster scroll
        });
        return () => {
          revealElements.forEach((element) => {
            observer.unobserve(element);
          });
        };
        
      }, []);

      useEffect(() => {
        const container = containerRef.current;
    
        // Function to handle mouse/touch move
        const handleMove = (e) => {
          const isTouch = e.type === "touchmove"; // Determine if the event is a touch event
          const currentTime = Date.now();
          const timeSinceLastImage = currentTime - lastCreatedTimeRef.current;
    
          const boundingRect = container.getBoundingClientRect();
          const cursorX = isTouch
            ? e.touches[0].clientX - boundingRect.left
            : e.clientX - boundingRect.left;
          const cursorY = isTouch
            ? e.touches[0].clientY - boundingRect.top
            : e.clientY - boundingRect.top;
    
          // Calculate the distance the cursor has moved since the last image
          const deltaX = cursorX - lastPositionRef.current.x;
          const deltaY = cursorY - lastPositionRef.current.y;
          const distanceMoved = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    
          // Determine the threshold based on screen width (responsive)
          const distanceThreshold = window.innerWidth < 768 ? 50 : 100;
    
          // Only create a new image if more than the calculated threshold has been moved
          if (distanceMoved < distanceThreshold) return;
    
          lastPositionRef.current = { x: cursorX, y: cursorY }; // Update the last cursor position
          lastCreatedTimeRef.current = currentTime; // Update the last created time
    
          // Create an image element dynamically
          const img = document.createElement("img");
          img.src = images[imageIndexRef.current];
          img.className = "animated-image";
          img.style.position = "absolute"; // Ensure the image is positioned absolutely
          img.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0px)`;
    
          // Append the image to the container
          container.appendChild(img);
    
          // Animate the image with a fade-in and fade-out effect
          gsap.fromTo(
            img,
            {
              opacity: 0, // Start with fully transparent
              scale: 0.5, // Start with smaller scale
              transform: `translate3d(${cursorX}px, ${cursorY}px, 0px)`,
            },
            {
              opacity: 1, // Fade in to fully visible
              scale: 1, // Scale up to normal size
              duration: 0.5, // Duration for fade-in effect
              ease: "power1.out",
              onComplete: () => {
                // After fade-in, start fade-out animation
                gsap.to(img, {
                  opacity: 0, // Fade out to transparent
                  duration: 0.5, // Duration for fade-out effect
                  ease: "power1.in",
                  onComplete: () => {
                    container.removeChild(img); // Remove the image after fade-out
                  },
                });
              },
            }
          );
    
          // Update the image index to loop through the images array
          imageIndexRef.current = (imageIndexRef.current + 1) % images.length;
        };
    
        // Add event listeners for both mouse and touch movements
        container.addEventListener("mousemove", handleMove);
        container.addEventListener("touchmove", handleMove);
    
        // Clean up event listeners
        return () => {
          container.removeEventListener("mousemove", handleMove);
          container.removeEventListener("touchmove", handleMove);
        };
      }, []);
    
    
    const sendEmail = async (e) => {
        e.preventDefault();
        
        emailjs
        .sendForm('service_9goc3kc', 'template_bwd5z2i', form.current, {
          publicKey: 'C-UT0xEw9MYsiRYhA',
        })
        .then(
          () => {
            console.log('SUCCESS!');
          },
          (error) => {
            console.log('FAILED...', error);
          },
        );  
      };
      
    

    const slugs = [
        "typescript",
        "javascript",
        "react",
        "html5",
        "css3",
        "nodejs",
        "express",
        "nextjs",
        "amazonaws",
        "firebase",
        "vercel",
        "jest",
        "docker",
        "git",
        "github",
        "gitlab",
        "visualstudiocode",
        "figma",
        "python",
        "Angular",
        "mongodb",
        "konva",
      ];


    const AboutContent = [
        {
            name: 'karthikeyan',
            Nationality: 'Indian',
            Phone: '+91 9159028170',
            Email: 'karthikeyanskk20@gmail.com',
            Experience: '3+ years',
            Language: "English,Tamil",
            Freelance: "Available"
        }
    ]

    const handleWhatsAppClick = () => {
        const formattedMessage = encodeURIComponent('hi'); // Encode the message to handle special characters
        const whatsappUrl = `https://wa.me/${9159028170}?text=${formattedMessage}`;
        window.open(whatsappUrl, '_blank'); // Opens WhatsApp in a new tab
    };

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent);
    };


    return (
        <div id='smooth-scroll-container'>
        <div className='mainContent'>
        <div id='aboutWrapper' ref={refs?.aboutRef}>
            <div ref={containerRef} className='profileContent reveal'>
                <div className='userContent'>
                    <TypingAnimation
                     className="text-4xl font-bold text-black dark:text-white username"
                     duration={200}
                     text="
                     Hi
                     I'm Karthikeyan"
                    />
                    {/* <div className='username'></div> */}
                    <TypingAnimation
                     className="text-4xl font-bold text-black dark:text-white desigination"
                     duration={300}
                     text="
                     Front-End Developer"
                    />
                    {/* <div className='desigination'></div> */}
                    <div className='btn'>
                         <Button className='workBtn'  onClick={() => window.location.assign('/works')} content='View Work' circular size='large' />
                         <Button
                            className='contactBtn'
                            content='Contact Me'
                            onClick={() => {
                                refs?.contactRef.current.scrollIntoView({ behavior: 'smooth' });
                         }}
                        circular
                        size='large'
                       />
                    </div>
                </div>
                <div>
                    <div className='profile'>
                        <img src={profilePic} className='profilePic zoom_in show' alt='' />
                    </div>
                </div>

            </div>

            <div className='About reveal'>
                <h1 className='name'>About Me.</h1>
                <div className='line'></div>
            </div>

            <div className='aboutContent reveal'>
                <p> Dynamic React.js Developer with 3 years of experience in developing and implementing user interface components
 using React.js, Redux, Flux, and Webpack. Proficient in JavaScript, CSS, HTML, and experienced in optimizing front-end
 performance. Skilled in troubleshooting, documenting codebase, and collaborating with development teams to deliver
 top-notch user experiences.</p>
            </div>

            <div className="about-section reveal ">
            {Object.entries(AboutContent[0]).map(([key, value]) => (
                <div className='about-detail-main' key={key}>
                    <p className='about-detail'>{key}</p>
                    <p className='about-detail-info'>{value}</p>
                </div>
            ))}
        </div>
    <div ref={refs?.educationRef} className='reveal'>
        <Grid>
    <GridRow className='reveal'>
      <GridColumn mobile={16} tablet={8} computer={8}>
      <div className='About'>
        <div className='EducationCln'>Education.</div>
        <div className='line'></div>
    </div>
    <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>10th Grade</div>
                <div className='cursus university'>Madonna Matric Hr Sec School</div>
                <div className='cursus university'>2015 - 2016</div>
                <div className='cursus university'>83%</div>
            </div>
        </div>
      <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>12th Grade</div>
                <div className='cursus university'>Madonna Matric Hr Sec School</div>
                <div className='cursus university'>2017 - 2018</div>
                <div className='cursus university'>75%</div>
            </div>
        </div>
        <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>Automobile Engineering</div>
                <div className='cursus university'>SNS College Of Technology</div>
                <div className='cursus university'>2018 - 2022</div>
                <div className='cursus university'>8.9 CGPA</div>
            </div>
        </div>
      </GridColumn>
      
      <GridColumn mobile={16} tablet={8} computer={8} >
      <div className='About'>
        <div className='EducationCln'>Experience.</div>
        <div className='line'></div>
    </div>
      <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>Software Developer Intern</div>
                <div className='cursus university'>Amphisoft Technologies Pvt. Ltd</div>
                <div className='cursus university'>Feb 2022 - Oct 2022 · 9 mos</div>
                <div className='cursus university'>Coimbatore, Tamil Nadu, India</div>
            </div>
        </div>
        <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>Product Engineer</div>
                <div className='cursus university'>Freckled </div>
                <div className='cursus university'>Nov 2022 - May 2024 · 1 yr 7 mos</div>
                <div className='cursus university'>Bengaluru, Karnataka, India</div>
            </div>
        </div>
        <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>Marketing Clould Associate</div>
                <div className='cursus university'>Fulgora Technologies Private Limited</div>
                <div className='cursus university'>Jun 2024 - Oct 2024 ·5 mos</div>
                <div className='cursus university'>Tirunelveli, Tamil Nadu, India</div>
            </div>
        </div>
        <div className='Education1'>
            <div className='side_circle_ring'>
                <div className='small_yellow_border'>
                <div className='small_yellow_circle'></div>
                </div>
            </div>
            <div>
                <div className='bachelor'>Associate Software Engineer</div>
                <div className='cursus university'>Katomaran Technologies</div>
                <div className='cursus university'>Nov 2024 - Present</div>
                <div className='cursus university'>Coimbatore, Tamil Nadu, India</div>
            </div>
        </div>
      </GridColumn>
    </GridRow>
  </Grid>
  </div>

        </div>

<div ref={refs?.skillsRef} className='reveal'>
    <div className='About reveal'>
        <div className='EducationCln '>Skills.</div>
        <div className='line'></div>
    </div>

    <div className="relative flex h-full w-full max-w-[32rem] items-center justify-center overflow-hidden rounded-lg border bg-background px-20 pb-20 pt-8">
      <IconCloud iconSlugs={slugs} />
    </div>
</div>

    <div className='blogWrapper reveal'  ref={refs?.blogRef}>
    <div className='About'>
        <div className='EducationCln reveal'>Blogs.</div>
        <div className='line'></div>
    </div>
    <div className='Blog1' onClickCapture={() =>  window.location.href = 'https://medium.com/@karthikeyanskk20/highlights-from-react-conf-2024-future-of-react-and-key-announcements-ec893c3a1f12'}>   
            <img src={ReactConf} alt='' className='blog1Img reveal' />
        <div className='reveal'>
            <div className='cursus university'>               
                Jul 11, 2024
            </div>
            <div className='bachelor'>
                Highlights from React Conf 2024: Future of React and Key Announcements
            </div>
        </div>
    </div>
    </div>

    <div className='contactWrapper reveal' ref={refs?.contactRef}>
    <div className='About'>
        <div className='EducationCln reveal'>Reach out me.</div>
        <div className='line'></div>
    </div>
    <div className='contactDetails reveal'>
        <div className='block1 reveal'>
          
            <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119953.71328281639!2d77.65977563438031!3d8.72155256890216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0411625053c519%3A0xad791b361b359a4d!2sTirunelveli%2C%20Tamil%20Nadu!5e1!3m2!1sen!2sin!4v1724247701326!5m2!1sen!2sin" 
            width={isMobileDevice() ? "325" : '450'} 
            height="250"
            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='address'></iframe>
          
            <div className='contactIcon reveal'>
                <Icon 
                name='linkedin' 
                size='huge' 
                color='blue' 
                link 
                onClickCapture={() => window.location.href='https://www.linkedin.com/in/karthikeyanrkk/'} />
                <Icon 
                    name="whatsapp" 
                    size="huge" 
                    color="green" 
                    onClick={handleWhatsAppClick} 
                    style={{ cursor: 'pointer' }} 
                />
                <Icon 
                    name="gitlab" 
                    size="huge" 
                    color="red" 
                    onClick={() => window.location.href='https://gitlab.com/karthikeyanskk20'} 
                    style={{ cursor: 'pointer' }} 
                />
                <Icon 
                    name="github" 
                    size="huge" 
                    color="grey"
                    onClick={() => window.location.href='https://github.com/karthii20'} 
                    style={{ cursor: 'pointer' }} 
                />
            </div>
        </div>
        <div className='block2 reveal'>
                <form onSubmit={sendEmail} ref={form}  >
            <div className='input1'>    
                    <div>
                        <label className='label'>Name</label><br />
                        <Input required placeholder='Name' name='user_name' />
                    </div>
                    <div>
                        <label className='label'>Email</label><br />
                        <Input required placeholder='Email' type='email' name='user_email' />
                    </div>
            </div>
            <div className='subjectinput'>
                <div>
                    <label className='label'>Subject</label><br />
                    <Input required placeholder='Subject' name='subject' fluid />
                </div>
            </div>
            <div className='textareaWrapper'>
                <div>
                    <label className='label'>Your message</label>
                    <TextArea required className='textarea' name='message'/>
                </div>
            </div>
            <Button color='black' fluid>Send message</Button>
                </form>
              
        </div>
    </div>
    </div>

        </div>
    </div>
    )
}

export default Main;